import { render, staticRenderFns } from "./TopWilayas.vue?vue&type=template&id=1973464a"
import script from "./TopWilayas.vue?vue&type=script&lang=js"
export * from "./TopWilayas.vue?vue&type=script&lang=js"
import style0 from "./TopWilayas.vue?vue&type=style&index=0&id=1973464a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports